import { render } from "./temp.vue?vue&type=template&id=30cda2a3&scoped=true"
import script from "./temp.vue?vue&type=script&lang=js"
export * from "./temp.vue?vue&type=script&lang=js"

import "./temp.vue?vue&type=style&index=0&id=30cda2a3&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cda2a3"]])

export default __exports__